import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all
}

const actions = {
  fetchAll ({ rootGetters, commit }) {
    return new Promise((resolve) => {
      const routes = rootGetters['routes/getAll']
      let stations = []
      let viaLists = []
      for (let i = 0; i < routes.length; i++) {
        let station = []
        if (routes[i].course.Route.Point[0].Station !== undefined) {
          station.push(routes[i].course.Route.Point[0].Station.code)
        } else if (routes[i].course.Route.Point[1].Station !== undefined) {
          station.push(routes[i].course.Route.Point[1].Station.code)
        } else {
          station.push("")
        }
        if (routes[i].course.Route.Point[routes[i].course.Route.Point.length - 1].Station !== undefined) {
          station.push(routes[i].course.Route.Point[routes[i].course.Route.Point.length - 1].Station.code)
        } else if (routes[i].course.Route.Point[routes[i].course.Route.Point.length - 2].Station !== undefined) {
          station.push(routes[i].course.Route.Point[routes[i].course.Route.Point.length - 2].Station.code)
        } else {
          station.push("")
        }
        stations.push(station.join(":"))
        viaLists.push(routes[i].points[0].location.latitude + "," + routes[i].points[0].location.longitude + ":" + routes[i].points[routes[i].points.length - 1].location.latitude + "," + routes[i].points[routes[i].points.length - 1].location.longitude)
      }
      const params = {
        viaLists: viaLists,
        stations: stations
      }
      api.getTickets(params, rootGetters['user/getLang'])
        .then((tickets) => {
          commit('setTickets', tickets)
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setTickets (state, tickets) {
    state.all = tickets
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}